import { Icon, TEventrIcons } from "@eventr/common-storybook";
import { Box } from "@mui/material";

type HitBoxIconProps = {
  id?: string;
  onClick: () => void;
  disabled?: boolean;
  icon: TEventrIcons;
  colour?: string;
  align?: "center" | "start" | "end";
};

export default function HitBoxIcon({ id, onClick, disabled = false, icon, colour, align = "center" }: HitBoxIconProps) {
  return (
    <Box
      id={id}
      onClick={disabled ? undefined : onClick}
      sx={{
        width: 44,
        height: 44,
        display: "flex",
        alignItems: align,
        justifyContent: "center",
        cursor: disabled ? "default" : "pointer",
        pointerEvents: disabled ? "none" : "auto",
      }}
    >
      <Icon name={icon} iconColour={colour} />
    </Box>
  );
}
